import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PaidLandingPage from '../PaidLandingPage/PaidLandingPage';
import MarketingLandingPage from './MarketingLandingPage';
import { getPaidLandingPage } from 'store/modules/pages';

export default function MarketingLandingPageWrapper(props) {
	const location = useLocation();
	const dispatch = useDispatch();

	const isPaidLanding = useSelector(
		(state) =>
			state.experiments?.bucket?.sf_15731_plp_refactor_ssdc ==
			'variation',
	);

	const queryParams = location?.search
		? Object.fromEntries(new URLSearchParams(location.search))
		: {};

	if (isPaidLanding) {
		return (
			<PaidLandingPage
				{...props}
				queryParams={queryParams}
				getPaidLandingPage={(...args) =>
					dispatch(getPaidLandingPage(...args))
				}
			/>
		);
	}

	return (
		<MarketingLandingPage
			{...props}
			queryParams={queryParams}
			getPaidLandingPage={(...args) =>
				dispatch(getPaidLandingPage(...args))
			}
		/>
	);
}
